
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[callSlug]",
      function () {
        return require("private-next-pages/[callSlug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[callSlug]"])
      });
    }
  